var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.32399 0.20232L10.5549 4.8422C10.6064 4.9501 10.7094 5.02204 10.8124 5.04002L15.7033 5.84931C15.9951 5.90326 16.098 6.26294 15.8921 6.47875L12.3912 10.1295C12.3054 10.2194 12.2711 10.3273 12.2882 10.4532L13.0776 15.5787C13.1291 15.8664 12.8202 16.1002 12.58 15.9563L8.16954 13.5824C8.06657 13.5285 7.94644 13.5285 7.84348 13.5824L3.43304 15.9563C3.17562 16.1002 2.88388 15.8664 2.93537 15.5787L3.72478 10.4532C3.74194 10.3453 3.70762 10.2194 3.62182 10.1295L0.103766 6.46076C-0.102169 6.24495 0.0179596 5.88527 0.292539 5.83132L5.18349 5.02204C5.28645 5.00406 5.38942 4.93212 5.4409 4.82421L7.68902 0.20232C7.82631 -0.0674401 8.1867 -0.0674401 8.32399 0.20232Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.0c5364eb.svg";
export { ForwardRef as ReactComponent };